export { default } from './CompletionIcon';
